<template>
  <div>
    <div class="container">
      <el-row>
        <el-col :span="12">
          <div class="logo">
            <img src="../assets/img/newerp_logo_w.png" alt="" />
            <span>聚知优ERP企业管理系统</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="logo-r">
            <img src="../assets/img/nascc_registration_uplogo.png" alt="" />
          </div>
        </el-col>
      </el-row>
      <div class="bottom-bg">
        <div class="main">
          <div class="flex">
            <div class="item testyx">
              <div class="title">| 英文拼词大会 · ERP管理系统</div>
              <div class="btn">
                <a :href="erpUrlObj.erpUrl1" target="_blank"
                  ><img src="../assets/img/newerp_button1.png" alt=""
                /></a>
              </div>
              <div class="text">
                <img src="../assets/img/newerp_webicon.png" alt="" /> 官网：<a
                  href="http://www.spbcn.org/"
                  target="_blank"
                  >www.spbcn.org</a
                >
              </div>
              <div class="qr"><img src="../assets/img/1.jpg" alt="" /></div>
            </div>
            <div class="item">
              <div class="title">| 汉英双拼大会 · ERP管理系统</div>
              <div class="btn">
                <a :href="erpUrlObj.erpUrl2" target="_blank"
                  ><img src="../assets/img/newerp_button2.png" alt=""
                /></a>
              </div>
              <div class="text">
                <img src="../assets/img/newerp_webicon.png" alt="" /> 官网：<a
                  href="http://www.cebso.org/"
                  target="_blank"
                  >www.cebso.org</a
                >
              </div>
              <div class="qr"><img src="../assets/img/2.jpg" alt="" /></div>
            </div>
            <div class="item">
              <div class="title">| 环球文遗小使者 · ERP管理系统</div>
              <div class="btn">
                <a :href="erpUrlObj.erpUrl3" target="_blank"
                  ><img src="../assets/img/newerp_button3.png" alt=""
                /></a>
              </div>
              <div class="text">
                <img src="../assets/img/newerp_webicon.png" alt="" /> 官网：<a
                  href="http://www.ghacedu.com/"
                  target="_blank"
                  >www.ghacedu.com</a
                >
              </div>
              <div class="qr"><img src="../assets/img/3.jpg" alt="" /></div>
            </div>
            <div class="item">
              <div class="title">| AISB 英文拼词电竞大赛管理系统</div>
              <div class="btn">
                <a :href="erpUrlObj.erpUrl4" target="_blank"
                  ><img src="https://cdn.spbcn.org/web/AICompetition/imagelogo-color.png" alt=""
                /></a>
              </div>
              <div class="text">
                <img src="../assets/img/newerp_webicon.png" alt="" /> 官网：<a
                  href="http://www.aispellingbee.com/"
                  target="_blank"
                  >www.aispellingbee.com</a
                >
              </div>
              <div class="qr"><img src="../assets/img/4.jpg" alt="" /></div>
            </div>
          </div>
          <div class="footer">
            <!-- <img src="../assets/img/nascc_registration_downlogo.png" alt="" /> -->
             <el-popover v-for="(item,index) in list" :key="index"
              placement="top"
              width="200"
              trigger="hover">
              <div>
                <img class="qr-code" :src="item.codeUrl" alt="">
                <div class="phone"> <img class="icon" src="https://cdn.spbcn.org/spbcnapp/2025ui/icon-tel.png" alt=""/><MaskedPhone :phone="item.phone" /></div>
              </div>
              <div class="footer-item" slot="reference">
                <img class="footer-item-logo" :src="item.img" alt="">
                <div class="footer-item-text">
                  <div class="h1">{{ item.divisionName }}</div>
                  <div class="h2">代表处</div>
                </div>
              </div>
            </el-popover>
            <div class="footer-item">
              <img src="https://cdn.spbcn.org/spbcnapp/2025ui/icon-tel.png" alt=""/>
              <div class="h1">4008-365-587</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'navmenu',
  data () {
    return {
      list: [
        {
          divisionName: '北京',
          phone: '13683692870',
          img: 'https://cdn.spbcn.org/spbcnappneed/lianxi_logo1.png',
          codeUrl: 'https://cdn.spbcn.org/spbcnapp/2025ui/qr-beijing.png'
        }, {
          divisionName: '天津',
          phone: '15510803713',
          img: 'https://cdn.spbcn.org/spbcnappneed/lianxi_logo2.png',
          codeUrl: 'https://cdn.spbcn.org/spbcnapp/2025ui/qr-tianjin.jpg'
        }, {
          divisionName: '上海',
          phone: '18016372779',
          img: 'https://cdn.spbcn.org/spbcnappneed/lianxi_logo3.png',
          codeUrl: 'https://cdn.spbcn.org/spbcnapp/2025ui/qr-huadong.png'
        }, {
          divisionName: '杭州',
          phone: '18016372779',
          img: 'https://cdn.spbcn.org/spbcnapp/2025ui/hangzhou.png',
          codeUrl: 'https://cdn.spbcn.org/spbcnapp/2025ui/qr-huadong.png'
        }, {
          divisionName: '华南',
          phone: '13147018191',
          img: 'https://cdn.spbcn.org/spbcnappneed/lianxi_logo4.png',
          codeUrl: 'https://cdn.spbcn.org/spbcnapp/2025ui/qr-huanan.jpg'
        }, {
          divisionName: '西南',
          phone: '18982180797',
          img: 'https://cdn.spbcn.org/spbcnappneed/lianxi_logo5.png',
          codeUrl: 'https://cdn.spbcn.org/spbcnapp/2025ui/qr-xinan.jpg'
        },
        {
          divisionName: '网络选区',
          phone: '18701446437',
          img: 'https://cdn.spbcn.org/spbcnappneed/dongbeiphone.png',
          codeUrl: 'https://cdn.spbcn.org/spbcnapp/2025ui/qr-nationwide.jpg'
        }
      ]
    }
  },
  computed: {
    erpUrlObj () {
      // const prefix = window.location.href.includes('localhost') || window.location.href.includes('test') ? 'test.' : ''
      const prefix = process.env.NODE_ENV === 'production' ? '' : 'test.'
      // const newPrefix = process.env.NODE_ENV === 'production' ? 'new.' : 'news.'
      return {
        erpUrl1: process.env.NODE_ENV === 'development' ? `http://${window.location.host}/#/welcome` : `http://${prefix}erp.spbcn.org/#/welcome`,
        // erpUrl1: process.env.NODE_ENV === 'development' ? `http://${window.location.host}/#/login` : `http://erp.${newPrefix}spbcn.org/#/login`,
        erpUrl2: `http://${prefix}cebso.spbcn.org/#/welcome`,
        erpUrl3: `http://${prefix}erp.ghacedu.spbcn.org/`,
        erpUrl4: `http://${prefix || 'www.'}fengyongtech.com/#/pczxLogin`
      }
    }
  },
  created () {
    document.title = '聚知优ERP企业管理系统'
    document.querySelector('#favicon').href = 'favicon_jzy.ico'
    console.log(process.env.NODE_ENV)
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100vh;
  min-height: 680px;
  background-color: #b21723;
  position: relative;
}
.bottom-bg {
  background-color: #000;
  background-image: url(../assets/img/newerp_bg20.png);
  background-position: bottom right;
  background-size: auto 90%;
  background-repeat: no-repeat;
  width: 100%;
  height: 62%;
  position: absolute;
  z-index: 1;
  bottom: 0;
  left: 0;
  right: 0;
}
.logo {
  padding-left: 30px;
  padding-top: 30px;
  display: flex;
  align-items: flex-end;
  img {
    width: 80px;
  }
  span {
    color: #000;
    font-size: 26px;
    font-weight: bold;
    margin-left: 10px;
  }
}
.logo-r {
  text-align: right;
  margin-right: 60px;
  margin-top: 78px;
  img {
    height: 22px;
  }
}
.main {
  position: absolute;
  top: -80px;
  left: 120px;
  right: 100px;
  bottom: 0;
}
.flex {
  display: flex;
  justify-content: space-between;
}
.footer {
  position: absolute;
  bottom: 30px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  img {
    height: 36px;
    margin-right: 10px;
  }
  .footer-item{
    display: flex;
    align-items: center;
    margin: 0 20px;
    cursor: pointer;
  }
  .footer-item-text{
    text-align: center;
  }
  .h1{
    font-size: 16px;
    font-weight: bold;
    color: black;
    text-shadow:
    -1px -1px 0 white,
     1px -1px 0 white,
    -1px  1px 0 white,
     1px  1px 0 white;
  }
  .h2{
    font-size: 10px;
    font-weight: bold;
    color: black;
    text-shadow:
    -1px -1px 0 white,
     1px -1px 0 white,
    -1px  1px 0 white,
     1px  1px 0 white;
  }
}
.item {
  width: 25%;
}
.title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 12px;
}
.btn {
  width: 95%;
  height: 110px;
  border: 2px solid #000;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #b21723;
  cursor: pointer;
  img {
    height: 50px;
  }
  &:hover {
    background: #fa4d5b;
  }
}
.qr-code{
  width: 200px;
}
.phone{
  font-size: 16px;
  font-weight: bold;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  img{
    width: 26px;
    height: 26px;
    margin-right: 10px;
  }
}
.text {
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  a {
    color: #fff;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
  img {
    margin-right: 10px;
    width: 28px;
  }
}
.qr {
  width: 140px;
  margin: 40px auto 0;
  padding: 12px;
  background: #fff;
  border-radius: 100%;
  img {
    width: 100%;
    border-radius: 100%;
  }
}
</style>
